import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IError, IResponse } from 'src/app/_types/common.types';
import { IPlans } from 'src/app/_types/plan.types';
import { PlanService } from 'src/app/services/plan.service';

@Component({
  selector: 'app-plan-selection-form',
  templateUrl: './plan-selection-form.component.html',
  styleUrls: ['./plan-selection-form.component.scss'],
})
export class PlanSelectionFormComponent {
  form!: FormGroup;
  planList: IPlans[] = [];
  subscriptionDetails: any;
  activeSubscriptionDetails: any;
  upcomingSubscriptionDetails: any;
  otherPlan: any

  constructor(
    private _FormBuilder: FormBuilder,
    private _PlanService: PlanService,
  ) {}

  ngOnInit(): void {
    this.form = this._FormBuilder.group({
      planId: ['', [Validators.required]],
    });
    // Get all available plans and set them to
    this._PlanService
      .planList()
      .subscribe({
        next: (response: Partial<IResponse>) => {
          if (response.success) {
            this.planList = response.data as IPlans[];
          }
        },
        error: (error: Partial<IError>) => {
          console.log('Inside error======', error);
        },
      });
  }
}
